module.exports = __webpack_public_path__ + "static/Transcend-26ef09c362517365ffaf90b53e2ca845.svg";